/* eslint-disable standard/no-callback-literal */
import auth from "@/modules/auth/services/auth";
import axios from "axios";
import router from "@/modules/global/router";
import store from "@/modules/global/stores";
// eslint-disable-next-line no-unused-vars

var http = axios.create({
    baseURL: process.env.API_BASE_URL,
    headers: { "Content-Type": "application/json" },
});

http.interceptors.response.use(
    function (response) {
        return response;
    },

    function (error) {
        if (error.response.status !== 401) return Promise.reject(error);

        var refreshAndRetry = new Promise(function (resolve) {
            axios
                .post(
                    process.env.API_BASE_URL + "account/refresh_token",
                    {
                        // eslint-disable-next-line no-undef
                        refresh_token: JSON.parse(
                            localStorage.getItem("refresh_token"),
                        ).value,
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            // eslint-disable-next-line no-undef
                            Authorization:
                                "Bearer " +
                                JSON.parse(localStorage.getItem("token")).value,
                        },
                    },
                )
                .then(function (response) {
                    // eslint-disable-next-line no-undef
                    localStorage.setItem(
                        "refresh_token",
                        JSON.stringify({
                            value: response.data.refresh_token,
                            expire: null,
                        }),
                    );

                    // eslint-disable-next-line no-undef
                    localStorage.setItem(
                        "token",
                        JSON.stringify({
                            value: response.data.token,
                            expire: null,
                        }),
                    );

                    return Promise.resolve(response);
                })
                .then(function (response) {
                    var failedRequest = error.config;
                    // eslint-disable-next-line no-undef
                    failedRequest.headers.Authorization =
                        "Bearer " +
                        JSON.parse(localStorage.getItem("token")).value;
                    axios.request(failedRequest).then(function (retryResponse) {
                        resolve(retryResponse);
                    });
                })
                .catch(function (err) {
                    var failedRequest = err.config;
                    // eslint-disable-next-line no-undef
                    var token = JSON.parse(localStorage.getItem("token")).value;
                    auth.doLogout(token, function (result) {
                        if (result.success) {
                            localStorage.clear();
                            store.commit("auth_destroyed");
                            router.push("/");
                        }
                    });

                    // eslint-disable-next-line no-undef
                    failedRequest.headers.Authorization =
                        "Bearer " +
                        JSON.parse(localStorage.getItem("token")).value;
                    axios.request(failedRequest).then(function (retryResponse) {
                        resolve(retryResponse);
                    });
                });
        });

        return refreshAndRetry;
    },
);

function getConfig() {
    return {
        headers: {
            // eslint-disable-next-line no-undef
            Authorization: JSON.parse(localStorage.getItem("token")).value,
        },
    };
}

function getListTemplates(callback) {
    var config = getConfig();
    http.get("notification/template/list", config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getTemplateDetail(id, callback) {
    var config = getConfig();
    http.get("notification/template/" + id + "/detail", config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getFeatureList(callback) {
    var config = getConfig();
    http.get("notification/feature/list", config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getServicesList(callback) {
    var config = getConfig();
    http.get("notification/services/list", config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function createNotificationTemplate(data, callback) {
    var config = getConfig();
    http.post("notification/template/create", data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function editNotificationTemplate(data, callback) {
    var config = getConfig();
    http.put("notification/template/" + data.id + "/update", data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function createFeature(data, callback) {
    var config = getConfig();
    http.post("notification/feature/create", data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

export default {
    getListTemplates,
    getTemplateDetail,
    getFeatureList,
    getServicesList,
    createNotificationTemplate,
    editNotificationTemplate,
    createFeature,
};



// WEBPACK FOOTER //
// ./src/modules/notifications_template/services/notifications_template.js